import { DisplayDateTimeFormat } from '@northfork/basics'
import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'

/**
 *Function to convert MST time to user current timezone
 */
export function currentTimezoneConverter(dateString: string): string {
  if (!dateString) {
    return ''
  }
  const trimmedDate = dateString.replace('Z', '').replace('T', ' ')
  const fromTimezone = 'America/Denver'
  const dateUtc = zonedTimeToUtc(trimmedDate, fromTimezone)

  // Convert the UTC time to the browser's timezone
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const date = utcToZonedTime(dateUtc.toISOString(), browserTimezone)

  // Format the final date in the desired format
  const formattedDate = format(date, DisplayDateTimeFormat, {
    timeZone: browserTimezone,
  })

  return formattedDate
}
